import { useTranslation } from "react-i18next";
import { ReactComponent as Times } from "@assets/images/times__close.svg";
import classes from "./NavList.module.scss";
import { TranslateFnType } from "../../../utils/models/languages";
import clsx from "clsx";
import { useLayoutEffect } from "react";
import { HashLink } from "react-router-hash-link";
import BaseLink from "@components/ui/BaseLink";

type PropsType = {
  isOpen: boolean;
  onClose: () => void;
};

const NavList = (props: PropsType) => {
  const { isOpen, onClose } = props;
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  useLayoutEffect(() => {
    if (!isOpen) {
      document.body.style.overflowY = "inherit";
      return;
    }

    document.body.style.overflowY = "hidden";
  }, [isOpen]);

  return (
    <div className={clsx(classes["nav"], { [classes.hidden]: !isOpen })}>
      <ul className={clsx(classes["nav-list"])}>
        <Times onClick={handleClose} className={classes["nav-list__close"]} />
        {links(t).map((link) => (
          <li key={link.path} className={classes["nav-list-item"]}>
            <HashLink
              smooth
              to={`/main${link.path}`}
              className={classes["nav-list-link"]}
              component={BaseLink}
              onClick={handleClose}
            >
              {link.text}
            </HashLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NavList;

const links = (t: TranslateFnType) => [
  {
    path: "#about",
    text: t("navigation.about"),
  },
  {
    path: "#projects",
    text: t("navigation.projects"),
  },
  {
    path: "#services",
    text: t("navigation.services"),
  },
  {
    path: "#solutions",
    text: t("navigation.solutions"),
  },
  {
    path: "#contacts",
    text: t("navigation.contacts"),
  },
];
